// Global context to share location
// ============================================

import React, { createContext, useContext } from "react";
import { useUserLocation } from "../hooks/useUserLocation";

const LocationContext = createContext(null);

export const LocationProvider = ({ children }) => {
  const { location, loading, error } = useUserLocation();

  return (
    <LocationContext.Provider value={{ location, loading, error }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error("useLocation must be used within LocationProvider");
  }
  return context;
};
